module.exports = __webpack_public_path__ + "img/6.6.CODm.58bf9d11.png";